module.exports = __webpack_public_path__ + "41771602154868d6d3b057a4fc9e3f34.svg";